import { Box, SectionHelper, Text } from "@wix/design-system";
import { InfoCircleSmall } from "@wix/wix-ui-icons-common";
import React, { useContext, useState } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
const LS_KEY = "ricos/color-picker/live-site-color-hint/closed";
const ColorPickerLiveSiteColorHint = () => {
  const { t } = useContext(RicosContext);
  const [isClosed, setIsClosed] = useState(() => !!localStorage?.getItem(LS_KEY));
  const onClose = () => {
    localStorage?.setItem(LS_KEY, "true");
    setIsClosed(true);
  };
  if (isClosed) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(SectionHelper, { appearance: "standard", onClose, size: "small", showCloseButton: true }, /* @__PURE__ */ React.createElement(Box, { direction: "horizontal", gap: "SP1" }, /* @__PURE__ */ React.createElement(Text, null, /* @__PURE__ */ React.createElement(InfoCircleSmall, null)), /* @__PURE__ */ React.createElement(Text, { size: "tiny", weight: "thin" }, t("ColorPickerLiveSiteColorHint")))));
};
export {
  ColorPickerLiveSiteColorHint
};
//# sourceMappingURL=live-site-color-hint.js.map
